var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"签约类型","clearable":"","size":_vm.size,"multiple":_vm.multiple,"collapse-tags":_vm.collapseTags},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}},_vm._l((_vm.MapSignType),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.label,"value":key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }